module.exports = __webpack_public_path__ + "img/icon_e23.22cc826d.png";